export const IMAGES_URL_BASE =
  process.env.REACT_APP_IMAGES_URL || 'https://images.upsuite.com'
